// src/components/Breadcrumb.js
import React from "react";
import styled from "styled-components";

const BreadcrumbContainer = styled.nav`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 16px;
`;

const Crumb = styled.span`
  margin-right: 8px;
  cursor: pointer;
  color: #007bff;

  &:last-child {
    color: #000;
    cursor: default;
  }

  &:not(:last-child)::after {
    content: "|";
    margin-left: 8px;
    color: #aaa;
  }
`;

const Breadcrumb = ({ items }) => {
  return (
    <BreadcrumbContainer>
      {items.map((item, index) =>
        <Crumb key={index}>
          {item}
        </Crumb>
      )}
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
